import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

export type TextFieldProps = MuiTextFieldProps;

const radius = 6;

const inputRootSx = {
  borderRadius: `${radius}px`,
  fontSize: 13,
  '& .MuiOutlinedInput-input': {
    py: '10px',
    px: 1.5,
  },
  '& fieldset': {
    borderColor: 'rgba(106, 114, 130, 0.25)',
    borderWidth: '0.974px',
  },
  '&:hover fieldset': {
    borderColor: 'rgba(106, 114, 130, 0.45)',
  },
  '&.Mui-focused fieldset': {
    borderColor: 'rgba(30, 42, 57, 0.55)',
  },
} as const;

export function TextField({ size = 'small', InputProps, sx, ...rest }: TextFieldProps) {
  const { sx: inputSx, ...restInputProps } = InputProps ?? {};
  const mergedInputSx =
    inputSx != null && typeof inputSx === 'object' && !Array.isArray(inputSx)
      ? { ...inputRootSx, ...inputSx }
      : inputRootSx;

  return (
    <MuiTextField
      size={size}
      fullWidth
      variant="outlined"
      InputProps={{
        ...restInputProps,
        sx: mergedInputSx,
      }}
      sx={{
        '& .MuiInputBase-root': {
          minHeight: 40,
        },
        ...sx,
      }}
      {...rest}
    />
  );
}
